import React from "react";

const GlobalConfig = new window.globalConfig();

class App extends React.Component {
  constructor(props) {
    super();
    this.state = {
      name: props.name,
      urlapi: GlobalConfig.REACT_APP_API_TIER_URL,
      value: props.value,
      data: [],
    };
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
  }

  async componentDidMount() {
    //using for parent call method setSelected outside
    this.props.onRef(this);

    //query all items in module and render as checkbox list
    this.getItems();
  }

  componentWillUnmount() {
    //using for parent call method setSelected outside
    this.props.onRef(undefined);
  }

  getItems = async () => {
    try {
      const that = this;
      fetch(this.state.urlapi).then(function (response) {
        return response.json();
      })
        .then(function (resultObject) {
          if (resultObject && resultObject.result === "OK" && resultObject.data) {
            const parsedItems = [];
            resultObject.data.map((item) => {
              parsedItems.push({
                _id: item._id,
                name: item.name,
                checked:
                  that.state.value === null ||
                    that.state.value === undefined ||
                    that.state.value === "" ||
                    that.state.value.indexOf(item._id) === -1
                    ? false
                    : true,
              });
            });
            that.setState({
              data: parsedItems,
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  setSelected(selectedIds) {
    this.setState({ value: selectedIds });
    if (this.state.data) {
      let updatedData = this.state.data;
      updatedData.forEach((item) => {
        if (
          selectedIds == null ||
          selectedIds === undefined ||
          selectedIds.indexOf(item._id) === -1
        ) {
          item.checked = false;
        } else {
          item.checked = true;
        }
      });
      this.setState({ data: updatedData });
    }
  }

  handleChangeSelect(event) {
    const value = event.target.value;
    this.setState({ value: value });
    this.props.handleChangeSelectGrower(this.state.name, value);
  }

  render() {
    return (
      <select
        disabled={this.props.readOnly}
        name={this.state.name}
        className="form-control"
        required={this.props.required}
        onChange={this.handleChangeSelect}
        value={this.state.value}
      >
        <option value="" disabled>Select New Tier</option>
        {this.state.data
          ? this.state.data.map((item, key) => {
            return (
              <option value={item._id} key={item._id}>
                {item.name}
              </option>
            );
          })
          : ""}
      </select>
    );
  }
}
export default App;
